module.exports = __webpack_public_path__ + "img/quanqiu.05bc6632.svg";